import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { loadAgencyUsage } from '~/api/data/usage/queries';
import { Action, Resource } from '~/api/graphql';
import { ProtectedRoute } from '~/components/permissions';
import { SettingsUsageRoute } from '~/pages/settings';

export const usageRoute: RouteObject = {
  path: 'usage',
  loader: merge({
    agencyUsage: loadAgencyUsage
  }),
  element: (
    <ProtectedRoute
      permissions={[{ resource: Resource.Subscription, action: Action.Update }]}
      redirectTo="/app/settings/profile"
    >
      <SettingsUsageRoute />
    </ProtectedRoute>
  )
};
